import { render } from "./EditPostModal.vue?vue&type=template&id=1d72b0b8&scoped=true"
import script from "./EditPostModal.vue?vue&type=script&lang=js"
export * from "./EditPostModal.vue?vue&type=script&lang=js"

import "./EditPostModal.vue?vue&type=style&index=0&id=1d72b0b8&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d72b0b8"]])

export default __exports__